// Home - Carrusel productos (sections/home-product-carousel.liquid)
// Arrows scroll the native track by 75% of its width, like the prototype

const HOME_CAROUSEL_STEP = 0.75

class HomeProductCarousel extends HTMLElement {
	connectedCallback() {
		this.track = this.querySelector("[data-carousel-track]")
		if (!this.track) return

		this.querySelector("[data-carousel-prev]")?.addEventListener("click", () => this.scrollByStep(-1))
		this.querySelector("[data-carousel-next]")?.addEventListener("click", () => this.scrollByStep(1))
	}

	scrollByStep(direction) {
		this.track.scrollBy({ left: direction * this.track.clientWidth * HOME_CAROUSEL_STEP, behavior: "smooth" })
	}
}

if (!customElements.get("home-product-carousel")) customElements.define("home-product-carousel", HomeProductCarousel)
